import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

import YourFacility from '../../../components/FormFields/YourFacility';
import PageFieldSummary from '../../../components/PageFieldSummary';

export const pageTitle = 'Your school or training facility';
export const radioLabels = {
  Y: 'Yes',
  N: "No, I'll choose a different option",
};

// NOTE: Leaving useSchoolInProfile as is for now so that SIP forms are not affected
// NOTE 2: Using radioUI and radioSchema for the facility in your profile question because
// the value stored in the form data is the value itself, not a boolean.
const useFacilityInYourProfilePage = {
  uiSchema: {
    ...titleUI(pageTitle),
    'ui:description': YourFacility,
    'ui:objectViewField': PageFieldSummary,
    useSchoolInProfile: radioUI({
      title: 'Do you want to use the facility in your profile?',
      labelHeaderLevel: '4',
      labels: radioLabels,
    }),
  },
  schema: {
    type: 'object',
    required: ['useSchoolInProfile'],
    properties: {
      useSchoolInProfile: radioSchema(Object.values(radioLabels)),
    },
  },
  title: pageTitle,
};

export default useFacilityInYourProfilePage;
